import type { ContourProps } from './contour-definitions';
import type { Point } from './types/contour-definition-array-type';

import { ContourType } from './contour-definitions';

import { PointContour } from './point-contour';

export class AnnotationTextContour extends PointContour {
  private _text: string = '';

  constructor(
    props: Partial<ContourProps> & Pick<ContourProps, 'type' | 'label'>,
    point: Point[],
  ) {
    const { text } = props;
    if (!text || text.length === 0) {
      throw new Error('AnnotationTextContour - text property is required');
    }
    super(props, point);

    if (props.type !== ContourType.AnnotationTextContour) {
      throw new Error('AnnotationTextContour - Invalid contour type');
    }

    this._text = text;
  }
}
